import { render, staticRenderFns } from "./LocationsTab.vue?vue&type=template&id=42c4c89c"
import script from "./LocationsTab.vue?vue&type=script&lang=js"
export * from "./LocationsTab.vue?vue&type=script&lang=js"
import style0 from "./LocationsTab.vue?vue&type=style&index=0&id=42c4c89c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports